export function dispatchRenderReady(): void {
  document.dispatchEvent(new Event('render-ready'));
}
